import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=3be1bc1b&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=3be1bc1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../share_webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1bc1b",
  null
  
)

export default component.exports